/**
 * Service to handle HAL responses / requests
 */

import { Api } from 'domain/core';
import { useEffect, useState } from 'react';
import useFetch from '../../services/auth/fetch.service';
import { RJSFSchema } from '@rjsf/utils';

/**
 *
 * @param resource
 * @returns
 */
export const useSchemas = (
	id?: string
): {
	schema: RJSFSchema;
	uiSchema: RJSFSchema;
} => {
	const authFetch = useFetch();

	const [schema, setSchemas] = useState<RJSFSchema>({});
	const [uiSchema, setUiSchemas] = useState<RJSFSchema>({});

	const fetchSchemas = async () => {
		try {
			const response = await authFetch(
				`${Api.baseUrl}${Api.schemas.base}/${id}`
			);
			const data = await response.json();
			// Check if data contains schemas key
			setSchemas(data.schema);
			setUiSchemas(data.uiSchema);
		} catch (err) {
			console.error(err);
		}
	};

	useEffect(() => {
		if (id) {
			fetchSchemas();
		}
	}, []);

	return {
		schema,
		uiSchema,
	};
};
